var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgASchoolSymbol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 197,
    height: 170,
    viewBox: "0 0 197 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-A-School_symbol"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 170
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A-School_symbol",
    clipPath: "url(#clip-A-School_symbol)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_6",
    "data-name": "\\uADF8\\uB8F9 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19",
    "data-name": "\\uD328\\uC2A4 19",
    d: "M33.324,12.37a23.469,23.469,0,0,0-2.277,11.736c.35,7.832,4.18,16.608,10.78,21.158.11.077.411.134.232.3C31.474,40.445,15.822,44.422,9.14,54.116c-.077.11-.134.407-.3.232C13.963,43.759,9.986,28.111.288,21.426c-.11-.073-.411-.134-.232-.3,10.78,5.075,25.558,1.265,32.719-8.2.053-.069.492-.972.549-.549",
    transform: "translate(0.001 37.589)",
    fill: "#4713b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_20",
    "data-name": "\\uD328\\uC2A4 20",
    d: "M159.992,139.7,85.152,10.077a20.153,20.153,0,0,0-34.907,0L11.1,77.869s70,20.45,110.381,84.811l-.02,0a31.493,31.493,0,0,0,18.5,7.251h2.57a20.153,20.153,0,0,0,17.453-30.23",
    transform: "translate(34.053 0.002)",
    fill: "#4713b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_21",
    "data-name": "\\uD328\\uC2A4 21",
    d: "M34.034,103.148c8.584-.732,16.778-5.12,22.976-11.451l.1-.159c11.724-17.136,4.742-35.5-4.534-49.091A137.686,137.686,0,0,0,33.924,21.773L4.385,72.938a20.153,20.153,0,0,0,17.453,30.23h12.2v-.02",
    transform: "translate(5.073 66.769)",
    fill: "#4713b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_22",
    "data-name": "\\uD328\\uC2A4 22",
    d: "M142.538,111.215C145.149,55.56,11.1,19.149,11.1,19.149A257.99,257.99,0,0,1,54.059,39.242c2.5,1.472,4.908,2.96,7.251,4.457l1.936,1.293,3.9,2.684,3.753,2.7,3.326,2.468,3.587,2.773,3.139,2.546L84.078,60.8l2.912,2.574,3.347,3.082,3.278,3.127,2.33,2.318,2.485,2.542,2.029,2.135,2.265,2.476,2.021,2.289,1.191,1.395L107.823,85l2.163,2.692.915,1.171,1.175,1.541,1.163,1.557,1.151,1.557.679.943,1.322,1.867.907,1.305.63.931,1.094,1.631.915,1.391.647.984.882,1.391.891.736.846.622,1.122.752.809.508.927.541.427.2c.553.309,1.1.594,1.643.854l.647.338,1.273.561,1.456.549.862.277.984.272-.012-.016a25.97,25.97,0,0,0,9.2,1.057",
    transform: "translate(34.053 58.722)",
    fill: "#65cafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    d: "M48.3,80.139a37.871,37.871,0,0,0,.582-12.3c-.565-7.108-4.636-24.724-29.12-46.069,0,0,46.6,44.109-13.485,81.424H19.263l.606-.028.789-.1s21.008-1.862,26.8-19.775a6.523,6.523,0,0,0,.618-1.976l0-.02c.089-.37.142-.777.22-1.159",
    transform: "translate(19.242 66.769)",
    fill: "#ed6ed7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgASchoolSymbol);
export default __webpack_public_path__ + "static/media/a-school-symbol.af15b9d46acda5e0b48043dfccd38e96.svg";
export { ForwardRef as ReactComponent };